import { BROADCAST_SET_STREAM_STATUS } from '../Types';

/**
 *
 * @param {Object} streamStatus
 * @param {boolean} streamStatus.isRecording
 * @param {boolean} streamStatus.isStreaming
 *
 */
const setStreamStatus = streamStatus => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_STREAM_STATUS,
      payload: streamStatus
    };

    dispatch(action);
  };
};

export default setStreamStatus;
